import * as Yup from 'yup';

export const editGenieAssistantsYopValidation = () => {
  return Yup.object().shape({
    activeAllAssistants: Yup.array().required().min(1, 'pleaseChooseAtLeastOneAssistant'),
  });
};
